import { useState, useEffect } from 'react';
export type sessionStorageHook = {
  value: string;
  setValue: (value: string) => void;
  removeValue: ()=>void
}


const useSessionStorage = (key: string): sessionStorageHook => {
  const fullkey = "chat-widget-"+key
  const [value, setStoredValue] = useState(sessionStorage.getItem(fullkey) || "");

  const setValue = (value: string) => {
    sessionStorage.setItem(fullkey, value);
    setStoredValue(value);
  }; 
  const removeValue = () => {
    sessionStorage.removeItem(fullkey)
  }
  return { value, setValue, removeValue };
};

export default useSessionStorage;
